import { getSafeTextColor } from "../lib/color-utils";

interface FooterProps {
  hideBranding?: boolean;
  primaryColor?: string;
}

export function Footer({ hideBranding = false, primaryColor }: FooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full py-8 mt-auto flex-shrink-0">
      <div className="max-w-7xl mx-auto px-4">
        {hideBranding ? (
          <p className="text-center text-[9px] text-slate-400 uppercase tracking-widest font-bold opacity-80">
            © {currentYear} Hajez • v0.9.0
          </p>
        ) : (
          <p className="text-center text-[10px] text-slate-500 uppercase tracking-[0.2em] font-bold opacity-80">
            Powered by{" "}
            <a
              href="https://krude.app"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-colors font-black tracking-normal lowercase text-[10px]"
              style={{ color: getSafeTextColor(primaryColor, "#64748b") }}
            >
              krude
            </a>
          </p>
        )}
      </div>
    </footer>
  );
}
